import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import {
  OrganizeTemplateIcon,
  PrepareToSendIcon,
} from 'DesignSystem/Icons';
import { SecondaryButton, PrimaryButton } from 'DesignSystem/Buttons';
import { SelfServeBuilderSidePanelTypes } from 'SelfServeBuilderSidePanel/SelfServeBuilderSidePanelConstants';
import { displayRecipientManager, displayOrganizer } from 'SelfServePostBuilderSidePanel/SelfServePostBuilderSidePanelActions';
import { openPanel } from 'SelfServeBuilderSidePanel/SelfServeBuilderSidePanelActions';


class OrganizeAndPrepareToSendButtons extends React.PureComponent {
  constructor(props) {
    super(props);

    this.openOrganizePanel = this.openOrganizePanel.bind(this);
    this.openRecipientPanel = this.openRecipientPanel.bind(this);
  }

  openOrganizePanel() {
    window._track('Organize', 'Template Builder');
    this.props.openPanel(SelfServeBuilderSidePanelTypes.POST_BUILDER);
    this.props.displayOrganizer();
  }

  openRecipientPanel() {
    window._track('Prepare To Send', 'Template Builder');
    this.props.openPanel(SelfServeBuilderSidePanelTypes.POST_BUILDER);
    this.props.displayRecipientManager();
  }

  render() {
    if (!this.props.isOpenPostBuilderSidePanel) {
      return (
        <React.Fragment>
          <SecondaryButton
            className="open-organizer-button"
            onClick={this.openOrganizePanel}
            icon={(<OrganizeTemplateIcon />)}
          >
            Organize
          </SecondaryButton>
          <PrimaryButton
            className="check-before-sending-button"
            onClick={this.openRecipientPanel}
            icon={(<PrepareToSendIcon />)}
          >
            Prepare To Send
          </PrimaryButton>
        </React.Fragment>
      );
    }
    return null;
  }
}

OrganizeAndPrepareToSendButtons.defaultProps = {
  displayOrganizer: () => {},
  displayRecipientManager: () => {},
};

OrganizeAndPrepareToSendButtons.propTypes = {
  displayOrganizer: PropTypes.func,
  displayRecipientManager: PropTypes.func,
  isOpenPostBuilderSidePanel: PropTypes.bool.isRequired,
  openPanel: PropTypes.func.isRequired,
};

const mapStateToProps = ({ SelfServeBuilderSidePanelHandler }) => ({
  isOpenPostBuilderSidePanel: SelfServeBuilderSidePanelHandler[
    SelfServeBuilderSidePanelTypes.POST_BUILDER
  ].isOpen,
});

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    displayRecipientManager,
    displayOrganizer,
    openPanel,
  }, dispatch)
);

export const OrganizeAndPrepareToSendButtonsWithRedux = connect(
  mapStateToProps,
  mapDispatchToProps,
)(OrganizeAndPrepareToSendButtons);

export default OrganizeAndPrepareToSendButtonsWithRedux;



// WEBPACK FOOTER //
// ./src-react/SelfServeBuilder/SelfServeBuilderToolbar/OrganizeAndPrepareToSendButtons.jsx